function i(s, a) {
  return s.classList ? !!a && s.classList.contains(a) : (" " + (s.className.baseVal || s.className) + " ").indexOf(" " + a + " ") !== -1;
}
export {
  i as default
};
//# sourceMappingURL=hasClass.mjs.map
